/**
 * Key / Value pair to translate API keys to better named, camelCased keys.
 * Any keys included in the request / response will be and not mapped here
 * will be removed.
 *
 * Any API response that returns an array of data will be mapped through
 * this object.
 *
 * @var {Object} transactionMap
 */
var transactionMap = {
  brand: 'brand',
  bulk_sent: 'bulkSent',
  cancelledCount: 'cancelledCount',
  cancelledValue: 'cancelledValue',
  claimedCount: 'claimedCount',
  claimedValue: 'claimedValue',
  created_at: 'createdAt',
  createdCount: 'createdCount',
  createdValue: 'createdValue',
  delivery_method: 'deliveryMethod',
  expiredCount: 'expiredCount',
  expiredValue: 'expiredValue',
  fetchedCount: 'fetchedCount',
  fetchedValue: 'fetchedValue',
  huggg_expiry: 'hugggExpiry',
  huggg_message: 'hugggMessage',
  id: 'id',
  maxHugggExpiryDate: 'maxHugggExpiryDate',
  maxSentDate: 'maxSentDate',
  notes: 'notes',
  notify_on_complete: 'notifyOnComplete',
  pendingCount: 'pendingCount',
  pendingValue: 'pendingValue',
  preview_shortcode: 'previewShortcode',
  processing: 'processing',
  product: 'product',
  purchased_at_date: 'purchasedAtDate',
  purchased_at_time: 'purchasedAtTime',
  quantity: 'quantity',
  reason_code: 'reasonCode',
  redeemed: 'redeemedCount',
  redeemedCount: 'redeemedCount',
  redeemedValue: 'redeemedValue',
  reference_id: 'referenceId',
  reference_type: 'referenceType',
  refunded: 'refundedCount',
  refundedValue: 'refundedValue',
  retail: 'retailPrice',
  sale_quantity: 'saleQuantity',
  scheduledCount: 'scheduledCount',
  scheduledValue: 'scheduledValue',
  sent: 'sentCount',
  sentCount: 'sentCount',
  sentValue: 'sentValue',
  stashed: 'stashedCount',
  stashedValue: 'stashedValue',
  status: 'status',
  stripe_fee_refunded: 'stripeFeeRefunded',
  super_url_id: 'superhugggId',
  tag: 'tag',
  totalValue: 'totalValue',
  type: 'type',
  updated_at: 'updatedAt',
  user_id: 'userId',
  user: 'user'
};
export default transactionMap;